import React, { useEffect } from "react";
import "./MaterialsListTab.css";
import DataTable from "../../DataTable/DataTable";
import { useConfiguration } from "src/contexts/ConfigurationContext";

const MaterialsListTab: React.FC = () => {
  const [shortHash, setShortHash] = React.useState("---");
  const shortHashRef = React.useRef(shortHash);
  const { request } = useConfiguration();

  const handleGetHash = async () => {
    const uuid = await request.getUUID();
    if (uuid !== "") setShortHash(uuid);
  };

  const handleCopy = () => {
    if (shortHash === "---") return;

    const urlWithShortHash = `${window.location.origin}/?offerte=${shortHash}`;

    if (
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function"
    ) {
      navigator.clipboard.writeText(urlWithShortHash);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = urlWithShortHash;
      textArea.style.position = "fixed"; // Avoid scrolling to bottom
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Fallback: Unable to copy", err);
      }

      document.body.removeChild(textArea);
    }

    shortHashRef.current = shortHash;
    setShortHash("Copied!");

    setTimeout(() => {
      setShortHash(shortHashRef.current);
    }, 1000);
  };

  useEffect(() => {
    if (
      shortHash !== "---" &&
      shortHash !== "Copied!" &&
      shortHash !== shortHashRef.current
    ) {
      handleCopy();
    }
  }, [shortHash]);

  return (
    <div className="materiaallijst-tab">
      <div className={'short-hash-container'}>
        <span className={'short-hash-field'} onClick={handleCopy}>{shortHash}</span>
        <button className={'short-hash-button short-hash-button__get'} onClick={handleGetHash}>
          Get & Copy
        </button>
      </div>
      <DataTable />
    </div>
  );
};

export default MaterialsListTab;
